import classnames from 'classnames/bind';
import React from 'react';
import PropTypes from 'prop-types';
import IconContainer from 'presentation/components/icons/IconContainer';

import styles from 'presentation/components/styles/__demo__/AnswerDisplay.css';
let cx = classnames.bind(styles);

export default function AnswerDisplay(props) {
  const AnswerDisplayProptypes = {
    name: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
  };
  PropTypes.checkPropTypes(AnswerDisplayProptypes, props, 'props', 'AnswerDisplay');

  const chevron = (
    <IconContainer viewBox="0 0 448 512">
      <path
        fill="currentColor"
        d="M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zM142.1 273l135.5 135.5c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L226.9 256l101.6-101.6c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L142.1 239c-9.4 9.4-9.4 24.6 0 34z"
      />
    </IconContainer>
  );

  return (
    <div className={cx(styles.answerDisplay)}>
      <div className={cx(styles.answerDisplay_title_wrapper)}>
        <div
          className={cx(styles.answerDisplay_icon)}
          role="button"
          tabIndex="0"
          onClick={props.onClick}
          onKeyDown={() => {}}
        >
          {chevron}
        </div>
        <div className={cx(styles.answerDisplay_title)}>{props.name}</div>
      </div>
      <div className={cx(styles.answerDisplay_body)}>{props.body}</div>
    </div>
  );
}
